import useKeepScroll from './useKeepScroll.hook';

export default function KeepScroll({ refs, keepIn, render }) {
  const { actions } = useKeepScroll({ refs, keepIn });
  return render(actions.keepScroll);
}
